@if ((selectedTrip$ | async); as selectedTrip) {
  @if ((deviationType$ | async); as deviationType) {
    <ng-container [formGroup]="trafficDeviationAffectedGroup">
      <fieldset>
        <span class="title">{{ 'Time span' | translate }}</span>
      </fieldset>
      <fieldset>
        <label class="label-above" for="startDate">
          {{ 'Start time' | translate }}
        </label>
        <div class="form-group flex-60">
          <app-form-date
            [control]="trafficDeviationAffectedGroup.controls.startDate"
            [readonly]="true"
            [id]="'startDate'"
            [showValidation]="true"
            [preValidate]="true">
          </app-form-date>
        </div>
        <div class="form-group flex-40">
          <app-form-time
            [control]="trafficDeviationAffectedGroup.controls.startTime"
            [readonly]="deviationType.journeyTiming || !!id"
            [id]="'startTime'"
            [showValidation]="true"
            [preValidate]="true">
          </app-form-time>
        </div>
      </fieldset>
      <fieldset>
        <label class="label-above" for="endDate">
          {{ 'End time' | translate }}
        </label>
        <div class="form-group flex-60">
          <app-form-date
            [control]="trafficDeviationAffectedGroup.controls.endDate"
            [readonly]="true"
            [id]="'endDate'"
            [showValidation]="true"
            [preValidate]="true">
          </app-form-date>
        </div>
        <div class="form-group flex-40">
          <app-form-time
            [control]="trafficDeviationAffectedGroup.controls.endTime"
            [readonly]="deviationType.journeyTiming || !!id"
            [id]="'endTime'"
            [showValidation]="true"
            [preValidate]="true">
          </app-form-time>
        </div>

        @if (isDateFieldsSet()) {
          <app-validation-message [control]="trafficDeviationAffectedGroup">
          </app-validation-message>
        }
      </fieldset>
      <div class="selected-vehicle-journey">
        @if (deviationType.connectionCancellation) {
          <p class="caption gray">{{ 'The following trip will cancel its connection' | translate }}</p>
        }
        <div class="vehicle-journey-container">
          <div class="journey-scope">
            <div class="route-info">
              <div class="route">{{ selectedTrip.routeName }}</div>
              <div class="trip">{{ selectedTrip.tripNumber }}</div>
            </div>
            <div class="time-scope">
              <span>{{ selectedTrip.startTime }}-{{ selectedTrip.endTime }}</span>
            </div>
            <span class="description" title="{{ selectedTrip.description }}">
              {{ selectedTrip.description }}
            </span>
            <div class="stop-point">
              @if (!deviationType.predictionInaccurate && !deviationType.deviationInformation && !id) {
                <div class="select">
                  @if (deviationType.journeyTiming) {
                    <p class="caption gray">{{ 'Applicable from' | translate }}</p>
                  }
                  @if (deviationType.connectionCancellation) {
                    <p class="caption gray">{{ 'Departing stop' | translate }}</p>
                  }
                  <button type="button" class="call text-tiny" (click)="selectStop('DEFAULT')">{{ selectedTrip.selectedPlace }}</button>
                </div>
              }
              @if (deviationType.journeyTiming) {
                <fieldset class="journey-timing">
                  <div class="form-group">
                    <label class="text-tiny" for="minutes">
                      {{ 'Delay in minutes' | translate }}
                    </label>
                    <div class="minutes">
                      <button type="button" (click)="subtract()">-</button>
                      <input type="number" min="0" id="minutes" formControlName="minutes" />
                      <button type="button" (click)="add()">+</button>
                    </div>
                    <div class="validation-message-wrapper">
                      @if (trafficDeviationAffectedGroup.controls.minutes.hasError('pattern')) {
                        <small>
                          {{ 'Has to start with [0-9]' | translate }}
                        </small>
                      }
                    </div>
                  </div>
                </fieldset>
              }
            </div>
          </div>
        </div>
        @if (
          trafficDeviationAffectedGroup.controls.minutes.touched
          || trafficDeviationAffectedGroup.controls.minutes.dirty
        ) {
          <app-validation-message
            [control]="trafficDeviationAffectedGroup.controls.minutes">
          </app-validation-message>
        }
      </div>
      @if (deviationType.connectionCancellation) {
        <ng-container formArrayName="routeInfo">
          <ng-container formGroupName="1">
            <fieldset>
              <p class="caption gray">{{ 'Connection' | translate }}</p>
            </fieldset>
            <fieldset class="connection-container">
              <app-form-select [label]="'Transportauthority'" [options$]="transportAuthorityOptions$"
                [control]="transportAuthorityOptions" [id]="'transportAuthority'" [disabled]="!!id">
              </app-form-select>
              @if ((selectedTransportAuthorityOption$ | async) === '1') {
                <div class="vehicle">
                  @if (!id) {
                    <div class="select">
                      <button type="button" class="item text-tiny" (click)="selectVehicle()">{{ 'Select arriving vehicle' | translate }}</button>
                    </div>
                  }
                </div>
              }
              @if ((selectedTransportAuthorityOption$ | async) === '8') {
                <div class="form-group">
                  <label for="routeName">{{ 'Route' | translate }}</label>
                  <input [readonly]="!!this.id" formControlName="routeName" id="routeName" type="text">
                </div>
                <div class="form-group">
                  <label for="tripNumber">{{ 'Trip' | translate }}</label>
                  <input [readonly]="!!this.id" formControlName="tripNumber" id="tripNumber" type="text">
                </div>
                @if ((connectionPointCallOptions$ | async)) {
                  <app-form-select [label]="'Stop'" [options$]="connectionPointCallOptions$" [control]="connectionPointCallOptions" [id]="'departureStopPoint'" [disabled]="!!id">
                  </app-form-select>
                }
              }

              @if ((selectedTransportAuthorityOption$ | async) === '1') {
                <app-validation-message [control]="connectionPointCallOptions">
                </app-validation-message>
              }
            </fieldset>
          </ng-container>
          @if ((selectedTransportAuthorityOption$ | async) === '1') {
            @if ((selectedConnection$ | async); as selectedConnection) {
              <div class="selected-vehicle-journey">
                <div class="vehicle-journey-container">
                  <div class="journey-scope">
                    <div class="route-info">
                      <div class="route">{{ selectedConnection.routeName }}</div>
                      <div class="trip">{{ selectedConnection.tripNumber }}</div>
                    </div>
                    <div class="time-scope">
                      <span>{{ selectedConnection.startTime }}-{{ selectedConnection.endTime }}</span>
                    </div>
                    <span class="description" title="{{ selectedConnection.description }}">
                      {{ selectedConnection.description }}
                    </span>
                    <div class="stop-point">
                      @if (!id) {
                        <div class="select">
                          @if (deviationType.connectionCancellation) {
                            <p class="caption gray">{{ 'Arriving stop' | translate }}</p>
                          }
                          <button type="button" class="call text-tiny" (click)="selectStop('CONNECTION')">{{ selectedConnection.selectedPlace }}</button>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            }
          }
        </ng-container>
      }
    </ng-container>
  }
}